import { render, staticRenderFns } from "./doctorActivityStatistics.vue?vue&type=template&id=b7a0c776&scoped=true"
import script from "./doctorActivityStatistics.vue?vue&type=script&lang=js"
export * from "./doctorActivityStatistics.vue?vue&type=script&lang=js"
import style0 from "./doctorActivityStatistics.vue?vue&type=style&index=0&id=b7a0c776&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a0c776",
  null
  
)

export default component.exports